(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pn-sale-price"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.pnSale) return;
    var SW = 1794805200000, END = 1798779600000;
    function rate(r1, r2, t) { if (!r1 || t >= END) return 0; return t >= SW ? r2 : r1; }
    function fmt(c) { return '$' + (c / 100).toFixed(2); }
    function final(el, cents) {
      var r = rate(+el.dataset.r1, +el.dataset.r2, Date.now());
      return Math.round(cents * (100 - r) / 100);
    }
    function update(el) {
      var c = +el.dataset.cents, r = rate(+el.dataset.r1, +el.dataset.r2, Date.now());
      el.innerHTML = r > 0
        ? '<s class="pn-sale__was">' + fmt(c) + '</s> <span class="pn-sale__now">' + fmt(Math.round(c * (100 - r) / 100)) + '</span>'
        : '<span class="pn-sale__now">' + fmt(c) + '</span>';
    }
    function run() { document.querySelectorAll('[data-pn-sale]').forEach(update); }
    window.pnSale = { rate: rate, fmt: fmt, final: final, update: update, run: run };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
    var wait = SW - Date.now();
    if (wait > 0 && wait < 2147483647) setTimeout(run, wait + 500);
  })();
  } catch(e) { console.error(e); }
})();

})();
